angular.module('bmsApp.training').controller('TrainingCalendarCtrl', function ($scope,
																			   $log,
																			   $modal,
																			   notify,
																			   uiCalendarConfig,
																			   TrainingRecordSvc,
																			   SharedTrainingSvc,
																			   ConfigService) {

	var momentFormat = ConfigService.config.format.date.amDbDateTime;

	$scope.uiConfig = {
		calendar: {
			height: '1200px',
			editable: true,
			selectable: true,
			eventOverlap: true,
			header: {
				left: 'prev,next today',
				center: 'title',
				right: 'month,basicWeek,basicDay'
			},
			lang: 'en-GB',
			select: function (start, end, jsEvent, view) {
				$scope.trainingCalendarSelect(start, end, jsEvent, view);
			},
			eventClick: function (event, jsEvent, view) {
				$scope.trainingCalendarEventClick(event, jsEvent, view);
			},
			eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
				$scope.trainingCalendarEventDrop(event, delta, revertFunc, jsEvent, ui, view);
			},
			eventResize: function (event, delta, revertFunc, jsEvent, ui, view) {
				$scope.trainingCalendarEventResize(event, delta, revertFunc, jsEvent, ui, view);
			}
		}
	};

	var trainingEvents = {
		events: function (start, end, timezone, callback) {
			var config = {
				params: {
					start: start.format(momentFormat),
					end: end.format(momentFormat)
				}
			};
			TrainingRecordSvc.allEmployeesCalendar(config.params)
				.then(function (response) {
					events = response.data.training_records;
					callback(events);
				}, function () {
					$log.error('Failed to load training record calendar');
				});
		}
	};

	// Set event sources for calendar (can use multiple sources)
	$scope.trainingEventSources = [trainingEvents];

	$scope.trainingCalendarSelect = function (start, end, jsEvent, view) {
		$log.info('Date(s) selected');
		var event = {
			start_date: start.clone().format(),
			end_date: end.clone().subtract(1, 'days').format()
		};
		$scope.trainingRecordModalForm(event);
	};

	$scope.trainingCalendarEventClick = function (event, jsEvent, view) {
		$log.info('Event clicked');
		if (event.object.type === 'local') {
			$scope.trainingRecordModalForm(event.object);
		}
		else {
			SharedTrainingSvc.showTrainingModal(event.object).then((result) => {
				if (result.refresh) {
					uiCalendarConfig.calendars['trainingCalendar'].fullCalendar('refetchEvents');
				}
			});
		}
	};

	$scope.trainingCalendarEventDrop = function (event, delta, revertFunc, jsEvent, ui, view) {
		$log.info('Event dropped');
		event.start_date = event.start.clone().format();
		event.end_date = event.end.clone().subtract(1, 'days').format();
		$scope.trainingRecordModalForm(event, revertFunc);
	};

	$scope.trainingCalendarEventResize = function (event, delta, revertFunc, jsEvent, ui, view) {
		$log.info('Event resized');
		event.start_date = event.start.clone().format();
		event.end_date = event.end.clone().subtract(1, 'days').format();
		$scope.trainingRecordModalForm(event, revertFunc);
	};

	$scope.trainingRecordModalForm = function (training_record, revertFunc) {

		if (angular.isUndefined(training_record)) {
			training_record = {
				start_date: moment().format(),
				end_date: moment().format()
			};
		}

		var modalInstance = $modal.open({
			animation: true,
			templateUrl: 'ng/employee/training/templates/TrainingRecordModalForm.html',
			controller: 'TrainingRecordModalFormCtrl',
			size: 'lg',
			scope: $scope,
			backdrop: 'static', // disable click-outside closing modal
			resolve: {
				training_record: function () {
					return angular.copy(training_record);
				}
			}
		});

		modalInstance.result.then(function (result) {
			if (result.success === true) {
				var message;
				switch (result.action) {
					case 'create':
						message = 'Training record created successfully';
						break;
					case 'update':
						message = 'Training record updated successfully';
						break;
					case 'delete':
						message = 'Training record deleted successfully';
						break;
					default:
						message = 'Success';
						break;
				}
				notify({
					message: message
				});
			}
			else {
				notify({
					mesage: result.error,
					classes: 'error'
				});
			}
			// reload calendar
			uiCalendarConfig.calendars['trainingCalendar'].fullCalendar('refetchEvents');
		}, function (error) {
			// modal closed
			if (angular.isUndefined(revertFunc) != true) {
				revertFunc();
			}
		});

	};

});
